import { createAction } from '@ngrx/store';
import {
  ActiveRisk,
  ActiveRiskDetails,
  Control,
  WarningBox,
} from 'projects/shared/src/lib/core/interfaces';
import { baseProps } from 'projects/shared/src/lib/core/store/actions-base';

export const fetchAllControlsForRisk = createAction(
  '[@diso/active-risks] fetchAllControlsForRisk',
  baseProps<{ riskId: string }>(),
);

export const fetchAllControlsForRiskSuccess = createAction(
  '[@diso/active-risks] fetchAllControlsForRiskSuccess',
  baseProps<{ controls: Control[] }>(),
);

export const fetchAllControlsForRiskFailure = createAction(
  '[@diso/active-risks] fetchAllControlsForRiskFailure',
);

export const fetchActiveRisks = createAction(
  '[@diso/active-risks] fetchActiveRisks',
  baseProps(),
);

export const fetchActiveRisksSuccess = createAction(
  '[@diso/active-risks] fetchActiveRisksSuccess',
  baseProps<{ activeRisks: ActiveRisk[]; warningBoxes: WarningBox }>(),
);

export const fetchActiveRisksFailure = createAction(
  '[@diso/active-risks] fetchActiveRisksFailure',
);

export const minimizeActionBox = createAction(
  '[@diso/active-risks] minimizeActionBox',
);

export const closeActionBox = createAction(
  '[@diso/active-risks] closeActionBox',
);

export const showNewRisks = createAction('[@diso/active-risks] showNewRisks');

export const hideNewRisks = createAction('[@diso/active-risks] hideNewRisks');

export const showUnhandledRisks = createAction(
  '[@diso/active-risks] showUnhandledRisks',
);

export const markRisksAsReviewed = createAction(
  '[@diso/active-risks] markRisksAsReviewed',
  baseProps<{ riskIds: string[] }>(),
);

export const openRiskSidebar = createAction(
  '[@diso/active-risks] openRiskSidebar',
  baseProps<{ riskId: string; risk?: ActiveRisk }>(),
);

export const closeRiskSidebar = createAction(
  '[@diso/active-risks] closeRiskSidebar',
);

export const fetchActiveRiskDetails = createAction(
  '[@diso/active-risks] fetchActiveRiskDetails',
  baseProps<{ riskId: string }>(),
);

export const fetchActiveRiskDetailsSuccess = createAction(
  '[@diso/active-risks] fetchActiveRiskDetailsSuccess',
  baseProps<{ riskDetails: ActiveRiskDetails }>(),
);

export const fetchActiveRiskDetailsFailure = createAction(
  '[@diso/active-risks] fetchActiveRiskDetailsFailure',
);

export const addRiskComment = createAction(
  '[@diso/active-risks] addRiskComment',
  baseProps<{ riskId: string; commentText: string }>(),
);

export const addRiskCommentSuccess = createAction(
  '[@diso/active-risks] addRiskCommentSuccess',
  baseProps<{
    comment: import('projects/shared/src/lib/core/interfaces').Comment;
  }>(),
);

export const addRiskCommentFailure = createAction(
  '[@diso/active-risks] addRiskCommentFailure',
);

export const setRiskCommentFailed = createAction(
  '[@diso/active-risks] setRiskCommentFailed',
  baseProps<{ failed: boolean }>(),
);

export const deselectRiskForControls = createAction(
  '[@diso/active-risks] deselectRiskForControls',
);

export const selectRiskForControls = createAction(
  '[@diso/active-risks] selectRiskForControls',
  baseProps<{ riskId: string; riskName: string }>(),
);

export const resetRisksState = createAction(
  '[@diso/active-risks] resetRisksState',
);
